import applyDiscount from "../applyDiscount";
import { buyValidationOptions } from "./buyValidationOptions";
import { payValidationOptions } from "./payValidationOptions"; // Add the discount tag

// Enable the submit button!
export function enableSubmitButton($submit = $(".submit")) {
  $submit.prop("disabled", false);
  $submit.removeClass("btn--disabled");
}

// Disable the submit button!
export function disableSubmitButton($submit = $(".submit")) {
  $submit.prop("disabled", true);
  $submit.addClass("btn--disabled");
}

// Logic to enable or disable submit button
export const enableOrDisableSubmitButton = function ($form) {
  // console.log($form);
  // if ($form.valid()) { // Checks if valid, but also runs validation
  let formOptions;
  if ($form === $(".questionsForm")) {
    formOptions = buyValidationOptions;
  } else if ($form === $(".paymentForm")) {
    formOptions = payValidationOptions;
  }
  if ($form.validate(formOptions).checkForm()) {
    // Checks if valid without running validation
    // console.log("Enabling submit");
    enableSubmitButton();
  } else {
    // console.log("Disabling submit");
    disableSubmitButton();
  }
  applyDiscount();
};

// Check if valid on input change
export const checkFormValidOnInputChange = function ($form) {
  $form.on("focusout change keyup", "input", function (e) {
    // console.log(e.type);
    enableOrDisableSubmitButton($form);
  });
};
